import paper from 'paper';

// Based on http://matthiasberth.com/articles/stable-zoom-and-pan-in-paperjs/

const PIXELS_PER_ZOOM_STEP = 100;

// https://github.com/facebookarchive/fixed-data-table/blob/e45114f7aa502c5d1e2ca006b82885c0b75f32c1/src/vendor_upstream/dom/normalizeWheel.js#L21-L23
const PIXELS_PER_LINE_WHEEL_DELTA = 40;
const PIXELS_PER_PAGE_WHEEL_DELTA = 800;

export function normalizeWheelDeltaY(deltaY: number, deltaMode: number) {
  switch (deltaMode) {
    case WheelEvent.DOM_DELTA_PIXEL:
    default: // not reachable
      return deltaY;

    case WheelEvent.DOM_DELTA_LINE:
      return deltaY * PIXELS_PER_LINE_WHEEL_DELTA;

    case WheelEvent.DOM_DELTA_PAGE:
      return deltaY * PIXELS_PER_PAGE_WHEEL_DELTA;
  }
}

export function getZoomFactorForWheelDelta(deltaY: number, baseZoomFactor: number) {
  return Math.pow(baseZoomFactor, -deltaY / PIXELS_PER_ZOOM_STEP);
}

export function changeZoom(
  oldZoom: number,
  zoomFactor: number,
  centerPoint: paper.Point,
  offsetPoint: paper.Point,
): readonly [number, paper.Point | null] {
  const newZoom = oldZoom * zoomFactor;

  // Zoom towards offsetPoint, not centerPoint (unless they're the same)
  let a = null;
  if (!centerPoint.equals(offsetPoint)) {
    const scalingFactor = oldZoom / newZoom;
    const difference = offsetPoint.subtract(centerPoint);
    a = offsetPoint.subtract(difference.multiply(scalingFactor)).subtract(centerPoint);
  }

  return [newZoom, a];
}

export function panCenter(oldCenter: paper.Point, viewDeltaX: number, viewDeltaY: number, zoom: number) {
  return oldCenter.add(new paper.Point(-viewDeltaX / zoom, -viewDeltaY / zoom));
}
